import React from "react";
import { Button, Slider } from "antd";
import { Play, Pause } from "./Buttons";
import PropTypes from 'prop-types';

export const PlaybackControls = ({ isPlaying, onPlaybackChange }) => (
  <Button
    type="link"
    style={{
      backgroundColor: "blue",
      padding: "2px",
      borer: "0px",
      borderRadius: "0px",
      color: "white",
      fontSize: "bold",
      cursor: "pointer",
      width: "2%",
      height: "100%",
    }}
    onClick={() => onPlaybackChange(!isPlaying)}
  >
    {isPlaying ? <Pause /> : <Play />}
  </Button>
);

PlaybackControls.propTypes = {
  isPlaying: PropTypes.bool,
  onPlaybackChange: PropTypes.func
}

export const ProgressBar = (props) => <Slider min={0} {...props} />;
